import { getEnv } from '../utils/index';
import { apiBaseUrl } from '../utils/baseUrl';

export const getAiSceneResourceDetail = async (
  scene: string,
  appVer: string,
  idList: { id: string; sub_type: string }[],
  longitude: string,
  latitude: string,
  vehicleInfo?: {
    vehicle_id: string;
    vehicle_longitude: string;
    vehicle_latitude: string;
    model_type: string;
    platform: string;
  },
) => {
  const env = await getEnv();
  const BaseUrl = apiBaseUrl[env];
  const res = await fetch(
    `${BaseUrl}/app/api/pe/map/v1/ai/scene-list?app_ver=${appVer}&hash_type=sha256`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        scene,
        id_list: idList,
        longitude,
        latitude,
        vehicle_info: vehicleInfo,
      }),
    }
  );
  return res.json();
};
